import { AccountCircleOutlined, Add, ArrowRightAlt, Clear, Close, Delete, Description, Edit, FilterAltOutlined, FilterOutlined, FolderOutlined, FolderSpecial, FolderSpecialTwoTone, KeyboardOutlined, MoreHoriz, PersonOutlineOutlined, Search } from '@mui/icons-material';
import { Avatar, Box, Breadcrumbs, Button, Chi, FormControlLabel, Radiop, CircularProgress, Divider, Fab, FormControl, Icon, IconButton, InputAdornment, InputLabel, MenuItem, Popover, Select, TextField, Typography, useMediaQuery, useTheme, Card, Skeleton, ToggleButton } from '@mui/material'
import { useApplicationContext } from '../../context/ApplicationContext';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import EditProjectDrawer from '../program/Edit';
import { addProject_API, deleteProject_API, getProjectCategoryList_API, getProjectList_API, getActivityLogs_API, getProjectSubcategoryList_API, updateProject_API } from '../../api/controller/ProjectController';
import { Settings_Module, ModulePath, Severity, Super_Admin_Module } from '../../constant/ApplicationVariables';
import { HttpStatusCode } from 'axios';
import useErrorHandler from '../../api/errorHandler/useErrorHandler';
import { useTranslation } from 'react-i18next';
import { lazy } from 'react';
import LicenseContainer from './license';
import StandaloneLicenseContainer from './StandaloneLicenseContainer';


const TemplateLoaderComponent = lazy(() => import('../loader/TemplateLoaderComponent'));
const LicenseAddOnContainer = lazy(() => import('./license/licenseAddOn'));
const LicensePackageContainer = lazy(() => import('./license/licensePackage'));
const InvoicesContainer = lazy(() => import('./invoices'));
const OrganisationsContainer = lazy(() => import('./organistations'));
const StandloneLicenseContainer = lazy(() => import('./StandaloneLicenseContainer'));



const Local_Modules = {
    organisation: Super_Admin_Module.organisation,
    license: Super_Admin_Module.license,
    licenseAddon: Super_Admin_Module.licenseAddon,
    invoices: Super_Admin_Module.invoices,
    StandloneLicenses: Super_Admin_Module.standaloneLicense,
};

export default function SuperAdminContainer() {
    const { handleSnackbar, activeSuperAdminModule, setActiveSuperAdminModule } = useApplicationContext();
    const theme = useTheme();
    const navigate = useNavigate();
    const errorHandler = useErrorHandler();
    const pathName = useLocation()?.pathname;
    const { t } = useTranslation('translation', { keyPrefix: 'project' });



    const [isLoading, setIsLoading] = useState(false);


    const handleChangeTabs = (module) => {
        setActiveSuperAdminModule(module);
    }


    const handleComponent = (module) => {
        switch (module) {
            case Local_Modules.organisation: return <OrganisationsContainer />
            case Local_Modules.license: return <LicenseContainer />
            // case Local_Modules.licenseAddon: return <LicenseAddOnContainer />
            case Local_Modules.invoices: return <InvoicesContainer />
            case Local_Modules.StandloneLicenses: return <StandaloneLicenseContainer />
            default: return null
        }
    }


    return (
        <Box className=" flex flex-col gap-4 px-0 py-0 relative h-full w-full overflow-hidden " >


            {isLoading && <TemplateLoaderComponent />}


            {/* main container */}
            <Box className="  grow flex flex-col gap-4 overflow-hidden " >
                {handleComponent(activeSuperAdminModule)}
            </Box>


        </Box>
    )
}